import BaseApi from './base';

class ClausulasConfirmacionApi extends BaseApi {
  constructor() {
    super('clausulas_confirmacion');
  }
}

export default new ClausulasConfirmacionApi();
